import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconSize } from '@wix/da-shared-react/pkg/Icons/IconWrap';
import UnwatchIcon from '@wix/da-shared-react/pkg/Icons/Unwatch';
import StandardDropdown from '@wix/da-shared-react/pkg/Dropdown/Preset/StandardDropdown';
import { PostsType } from '../../../../../../types/posts';

interface Props {
  isOwner: boolean;
  value: PostsType;
  onChange: (value: PostsType) => void;
  className?: string;
  counts: {
    [key in PostsType]: number;
  };
}

const PostsTypeSwitcher: React.FC<Props> = ({
  isOwner,
  value,
  onChange,
  className,
  counts = {},
}) => {
  const { t } = useTranslation();
  const items = useMemo(
    () =>
      [PostsType.ALL, PostsType.JOURNALS, PostsType.POLLS, PostsType.STATUSES]
        .map(postType => ({
          value: postType,
          label: t(
            /* i18n grep
             'pages.posts.types.all'
             'pages.posts.types.all_zero'
             'pages.posts.types.journals'
             'pages.posts.types.journals_zero'
             'pages.posts.types.polls'
             'pages.posts.types.polls_zero'
             'pages.posts.types.statuses'
             'pages.posts.types.statuses_zero'
           */
            `pages.posts.types.${postType}${counts[postType] ? '' : '_zero'}`,
            {
              count: counts[postType],
            }
          ),
          icon: undefined,
        }))
        .concat(
          !isOwner
            ? ([] as any)
            : [
                {
                  value: PostsType.DRAFTS,
                  label: t(
                    /* i18n grep
             'pages.posts.types.drafts'
             'pages.posts.types.drafts_zero'
           */
                    `pages.posts.types.${PostsType.DRAFTS}${
                      counts[PostsType.DRAFTS] ? '' : '_zero'
                    }`,
                    {
                      count: counts[PostsType.DRAFTS],
                    }
                  ),
                  icon: <UnwatchIcon size={IconSize.SMALL} />,
                },
              ]
        ),
    [t, isOwner, counts]
  );

  return (
    <StandardDropdown
      className={className}
      menuAlignment="left"
      selectedValue={value}
      onSelect={onChange}
      items={items}
    />
  );
};

PostsTypeSwitcher.displayName = 'PostsTypeSwitcher';
export default PostsTypeSwitcher;
